(() => {
  const bar = document.querySelector('[data-shopsta-sticky-cart]');
  const main = document.querySelector('#site-main .product-main');
  const form = main?.querySelector('form[data-product-form]');
  const selection = form?.querySelector('variant-selection');
  const mainButton = form?.querySelector('[data-product-atc]');
  if (!bar || !form || !selection || !mainButton || bar.dataset.ready) return;
  const button = bar.querySelector('[data-sticky-add]');
  const picker = bar.querySelector('[data-sticky-variant]');
  const options = bar.querySelector('.ssc__options');
  const price = bar.querySelector('[data-sticky-price]');
  const picture = bar.querySelector('[data-sticky-image]');
  const error = bar.querySelector('[data-sticky-error]');
  const spacer = document.querySelector('[data-sticky-cart-spacer]');
  const pricing = main.querySelector('[data-product-pricing]');
  const title = bar.querySelector('[data-sticky-title]');
  const rating = bar.querySelector('.ssc__rating');
  const reviewCount = bar.querySelector('[data-sticky-review-count]');
  const baseTitle = title.textContent;
  const originalImage = picture?.src;
  let product, variant, busy = false, changing = false, scheduled = false;
  const showError = message => { error.textContent = message; error.hidden = !message; };
  const updateButton = () => {
    button.disabled = busy || changing || !variant?.available || mainButton.disabled;
    button.textContent = busy ? bar.dataset.addingLabel : !variant ? bar.dataset.chooseLabel
      : !variant.available ? bar.dataset.soldOutLabel
      : mainButton.hasAttribute('data-product-atc-preorder') ? bar.dataset.preorderLabel : bar.dataset.addLabel;
    button.setAttribute('aria-busy', String(busy || changing));
  };
  const updateReviewCount = () => {
    if (!rating || !reviewCount || bar.hidden || window.innerWidth > 700) return;
    const available = rating.getBoundingClientRect();
    const count = reviewCount.getBoundingClientRect();
    // Visibility preserves its natural width, so a hidden count can fit again.
    reviewCount.toggleAttribute('data-count-fits', count.width > 0 && count.left >= available.left && count.right <= available.right);
  };
  const updatePosition = () => {
    scheduled = false;
    bar.hidden = mainButton.getBoundingClientRect().bottom > 0;
    spacer.style.height = bar.hidden ? '0px' : `${bar.getBoundingClientRect().height}px`;
    const currentPrice = pricing?.querySelector('[data-price-container] [data-price]');
    if (currentPrice && price.innerHTML !== currentPrice.innerHTML) price.innerHTML = currentPrice.innerHTML;
    updateButton();
    updateReviewCount();
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updatePosition); }
  };
  const sync = next => {
    variant = next || null;
    picker.value = variant ? String(variant.id) : '';
    title.textContent = variant && !product.has_only_default_variant && variant.title !== 'Default Title'
      ? `${baseTitle} - ${variant.title}` : baseTitle;
    if (picture) {
      const source = variant?.featured_image?.src || (typeof variant?.featured_image === 'string' ? variant.featured_image : originalImage);
      if (source) { const url = new URL(source, location.href); url.searchParams.set('width', '120'); if (picture.src !== url.href) picture.src = url.href; }
    }
    updateButton(); schedule();
  };
  const returnToProduct = () => {
    main.scrollIntoView({behavior: 'smooth', block: 'start'});
    mainButton.focus({preventScroll: true});
  };
  async function init() {
    await customElements.whenDefined('variant-selection');
    product = await selection.getProduct();
    if (!product?.variants?.length || !bar.isConnected) return;
    bar.dataset.ready = 'true';
    bar.toggleAttribute('data-no-rating', !bar.querySelector('[data-shopsta-native-rating]'));
    bar.toggleAttribute('data-no-image', !picture);
    if (product.variants.length > 1) {
      const placeholder = document.createElement('option');
      placeholder.value = ''; placeholder.textContent = bar.dataset.chooseLabel; placeholder.disabled = true;
      picker.append(placeholder);
      product.variants.forEach(item => {
        const option = document.createElement('option');
        option.value = String(item.id);
        option.textContent = item.title + (item.available ? '' : ` — ${bar.dataset.soldOutLabel}`);
        option.disabled = !item.available;
        picker.append(option);
      });
      options.hidden = false;
    }
    selection.addEventListener('variant-change', event => sync(event.detail.variant));
    picker.addEventListener('change', async () => {
      const next = product.variants.find(item => String(item.id) === picker.value);
      if (!next || busy) return;
      changing = true; updateButton(); showError('');
      try {
        let changedControl;
        form.querySelectorAll('[data-variant-option]').forEach(group => {
          const value = next.options[Number(group.dataset.variantOptionIndex)];
          if (group.tagName === 'SELECT') {
            group.value = value; changedControl = group;
          } else {
            group.querySelectorAll('input[data-variant-option-value]').forEach(input => {
              input.checked = input.value === value;
              if (input.checked) changedControl = input;
            });
          }
        });
        selection.variant = String(next.id);
        const variantInput = form.querySelector('[data-variants]');
        if (variantInput) variantInput.value = String(next.id);
        changedControl?.dispatchEvent(new Event('change', {bubbles: true}));
        sync(await selection.getVariant());
      } catch (_) { showError(bar.dataset.errorLabel); }
      finally { changing = false; updateButton(); }
    });
    button.addEventListener('click', async () => {
      if (busy || changing || button.disabled) return;
      if (!form.reportValidity()) return;
      busy = true; picker.disabled = true; updateButton(); showError('');
      let accepted = false;
      try {
        const current = await selection.getVariant();
        if (!current?.available) { sync(current); return; }
        const body = new FormData(form);
        body.set('id', String(current.id));
        const url = new URL(form.action, location.href);
        url.pathname = url.pathname.replace(/\/add\/?$/, '/add.js');
        const response = await fetch(url.href, {method: 'POST', headers: {'Accept': 'application/json', 'X-Shopsta-Cart': 'sticky'}, body});
        const result = await response.json();
        if (!response.ok || Number(result.status) >= 400) {
          showError(typeof result.description === 'string' ? result.description : bar.dataset.errorLabel);
          return;
        }
        accepted = true;
        if (window.ShopstaCart) await window.ShopstaCart.added(button);
        else location.assign(bar.dataset.cartUrl);
      } catch (_) {
        if (accepted) location.assign(bar.dataset.cartUrl);
        else showError(bar.dataset.connectionLabel);
      } finally {
        busy = false; picker.disabled = false; updateButton(); schedule();
      }
    });
    bar.querySelector('[data-sticky-product]').addEventListener('click', event => { event.preventDefault(); returnToProduct(); });
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    const observer = new MutationObserver(schedule);
    observer.observe(mainButton, {attributes: true, attributeFilter: ['disabled', 'class']});
    if (pricing) observer.observe(pricing, {childList: true, subtree: true, characterData: true});
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(bar);
      if (rating) resizeObserver.observe(rating);
      if (reviewCount) resizeObserver.observe(reviewCount);
    }
    sync(await selection.getVariant());
  }
  void init().catch(() => { bar.hidden = true; delete bar.dataset.ready; });
})();
